// @ts-nocheck

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import SoftBox from '../../components/common/softBox';
import SoftTypography from '../../components/common/softTypography';
import SoftButton from '../../components/common/softButton';
import { FaCirclePlus } from 'react-icons/fa6';
import { getMenuAccessItems, editMenuAccessItem, createMenuAccessItem } from '../../features/menuAccess';
import { labelMapping } from '../../utils/fileHelpers';
import DashboardNavbar from '../../components/navbars/dashboardNavbar';

const MenuAccess = () => {
  const dispatch = useDispatch();
  const menuAccessSectionData = useSelector((state) => state.menuAccess.menuAccessItems);
  console.log(menuAccessSectionData, 'menuAccessSectionData');

  const [menuData, setMenuData] = useState({
    home: {
      home: true,
      home_sections: {
        hero: true,
        aboutus: true,
        room: true,
        offer: true,
        services: true,
        testimonials: true,
        blogs: true
      }
    },
    about_us: {
      about_us: true,
      abutus_sections: {
        about_section: true,
        about_counter: true,
        about_team: true
      }
    },
    room_suits: {
      room_suits: true,
      room_suits_sections: {
        room_list: true,
        masonry_gallery: true
      }
    },
    dinning: {
      dinning: true,
      dinning_sections: {
        dinning_card: true,
        dinning_details: true,
        food_menu: true
      }
    },
    meeting_events: {
      meeting_events: true,
      meeting_events_sections: {
        event_plan: true,
        venue: true
      }
    },
    blogs: true,
    amenities: true,
    career: true,
    faq: true,
    gallery: true,
    contact: true,
    footer: true,



  });

  // Fetch current menu access data from the API
  useEffect(() => {
    dispatch(getMenuAccessItems())
      .then((response) => {
        if (response.payload) {
          if (response.payload.data) {

            setMenuData(response.payload.data);
          }
        }
      })
      .catch((error) => {
        toast.error("Error fetching menu access data.");
      });
  }, [dispatch]);

  const handleCheckboxChange = (section: string, value: boolean, isSub: boolean) => {
    console.log(value, 'value');
    console.log(section, 'section');
    if (isSub) {
      setMenuData((prevData) => ({
        ...prevData,
        [section]: {
          ...prevData[section],
          [section]: value
        }
      }));
    } else {
      setMenuData((prevData) => ({
        ...prevData,
        [section]: value
      }));
    }


  };

  const handleSubsectionChange = (menu: string, sub_menu: string, section: string, value: boolean) => {
    console.log(menu, 'menu');
    console.log(section, 'section');
    setMenuData((prevData) => ({
      ...prevData,
      [menu]: {
        ...prevData[menu],
        [sub_menu]: {
          ...prevData[menu][sub_menu],
          [section]: value
        }
      }
    }));
  };
  console.log(menuData, 'menuData');

  const handleSubmit = () => {
    console.log(menuAccessSectionData, 'menuAccessSectionData');

    if (menuAccessSectionData && menuAccessSectionData.data) {
      dispatch(editMenuAccessItem({ updatedMenuAccessItem: menuData }))
        .then((response) => {
          toast.success("Menu access updated successfully!");
        })
        .catch((error) => {
          toast.error("Failed to update menu access.");
        });
    } else {
      console.log(menuData, 'menuDatamenuData');

      dispatch(createMenuAccessItem(menuData))
        .then((response) => {
          toast.success("Menu access added successfully!");
        })
        .catch((error) => {
          toast.error("Failed to add menu access.");
        });
    }
  };
  console.log(menuData, 'menuData');

  return (
    <SoftBox >

      <SoftBox className="language-box menu-access ">
        <DashboardNavbar />

        <SoftTypography variant="h4" fontWeight="bold" textAlign="left" mb={3}>
          Manage Menu Access
        </SoftTypography>

        {/* Home Section */}
        <SoftBox mb={1.5} >

          <div className='d-align'>
            <input
              type="checkbox"
              checked={menuData.home.home}
              onChange={(e) => handleCheckboxChange('home', e.target.checked, true)}
            />
            <SoftTypography variant="h6" fontWeight="bold" display="inline-block" ml={1}>
              Home
            </SoftTypography>
          </div>
          {menuData && menuData.home.home && (
            <SoftBox ml={0}>
              {Object.keys(menuData.home.home_sections || {}).map((section) => (
                <div key={section}>
                  <input
                    type="checkbox"
                    checked={menuData.home.home_sections[section]}
                    onChange={(e) => handleSubsectionChange('home', 'home_sections', section, e.target.checked)}
                  />
                  <SoftTypography ml={1} variant="body1" component="span">{labelMapping[section]}</SoftTypography>
                </div>
              ))}
            </SoftBox>
          )}
        </SoftBox>

        {/* About Us Section */}
        <SoftBox mb={1.5}>
          <div className='d-align'>
            <input
              type="checkbox"
              checked={menuData.about_us.about_us}
              onChange={(e) => handleCheckboxChange('about_us', e.target.checked, true)}
            />
            <SoftTypography variant="h6" fontWeight="bold" display="inline-block" ml={1}>
              About Us
            </SoftTypography>
          </div>
          {menuData && menuData.about_us.about_us && (
            <SoftBox ml={0}>
              {Object.keys(menuData.about_us.abutus_sections || {}).map((section) => (
                <div key={section}>
                  <input
                    type="checkbox"
                    checked={menuData.about_us.abutus_sections[section]}
                    onChange={(e) => handleSubsectionChange('about_us', 'abutus_sections', section, e.target.checked, true)}
                  />
                  <SoftTypography ml={1} variant="body1" component="span">{labelMapping[section]}</SoftTypography>
                </div>
              ))}
            </SoftBox>
          )}
        </SoftBox>

        {/* Room Suites Section */}
        <SoftBox mb={1.5}>
          <div className='d-align'>
            <input
              type="checkbox"
              checked={menuData.room_suits.room_suits}
              onChange={(e) => handleCheckboxChange('room_suits', e.target.checked, true)}
            />
            <SoftTypography variant="h6" fontWeight="bold" display="inline-block" ml={1}>
              Room Suites
            </SoftTypography>
          </div>

          {menuData && menuData.room_suits.room_suits && (
            <SoftBox ml={0}>
              {Object.keys(menuData.room_suits.room_suits_sections || {}).map((section) => (
                <div key={section}>
                  <input
                    type="checkbox"
                    checked={menuData.room_suits.room_suits_sections[section]}
                    onChange={(e) => handleSubsectionChange('room_suits', 'room_suits_sections', section, e.target.checked, true)}
                  />
                  <SoftTypography ml={1} variant="body1" component="span">{labelMapping[section]}</SoftTypography>
                </div>
              ))}
            </SoftBox>
          )}
        </SoftBox>

        {/* Dining Section */}
        <SoftBox mb={1.5}>
          <div className='d-align'>
            <input
              type="checkbox"
              checked={menuData.dinning.dinning}
              onChange={(e) => handleCheckboxChange('dinning', e.target.checked, true)}
            />
            <SoftTypography variant="h6" fontWeight="bold" display="inline-block" ml={1}>
              Dining
            </SoftTypography>
          </div>

          {menuData && menuData.dinning.dinning && (
            <SoftBox ml={0}>
              {Object.keys(menuData.dinning.dinning_sections || {}).map((section) => (
                <div key={section}>
                  <input
                    type="checkbox"
                    checked={menuData.dinning.dinning_sections[section]}
                    onChange={(e) => handleSubsectionChange('dinning', 'dinning_sections', section, e.target.checked, true)}
                  />
                  <SoftTypography ml={1} variant="body1" component="span">{labelMapping[section]}</SoftTypography>
                </div>
              ))}
            </SoftBox>
          )}
        </SoftBox>

        {/* Meeting & Events Section */}
        <SoftBox mb={1.5}>
          <div className='d-align'>
            <input
              type="checkbox"
              checked={menuData.meeting_events.meeting_events}
              onChange={(e) => handleCheckboxChange('meeting_events', e.target.checked, true)}
            />
            <SoftTypography variant="h6" fontWeight="bold" display="inline-block" ml={1}>
              Meeting & Events
            </SoftTypography>
          </div>

          {menuData && menuData.meeting_events.meeting_events && (
            <SoftBox ml={0}>
              {Object.keys(menuData.meeting_events.meeting_events_sections || {}

              ).map((section) => (
                <div key={section}>
                  <input
                    type="checkbox"
                    checked={menuData.meeting_events.meeting_events_sections[section]}
                    onChange={(e) => handleSubsectionChange('meeting_events', 'meeting_events_sections', section, e.target.checked, true)}
                  />
                  <SoftTypography ml={1} variant="body1" component="span">{labelMapping[section]}</SoftTypography>
                </div>
              ))}
            </SoftBox>
          )}
        </SoftBox>

        {/* Other Sections (Blogs, Amenities, Career, FAQ, Gallery) */}
        {['blogs', 'amenities', 'career', 'faq', 'gallery', 'contact', 'footer'].map((section) => (
          <SoftBox key={section} mb={2}>
            <div className='d-align'>
              <input
                type="checkbox"
                checked={menuData[section]}
                onChange={(e) => handleCheckboxChange(section, e.target.checked, false)}
              />
              <SoftTypography variant="h6" fontWeight="bold">
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </SoftTypography>
            </div>

          </SoftBox>
        ))}

        <SoftButton color="final" onClick={handleSubmit}>Save Changes</SoftButton>
      </SoftBox>
    </SoftBox>
  );
};

export default MenuAccess;
